import {
  IonContent,
  IonPage,
  useIonViewDidEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import React, { useState } from 'react';
import './Default.css';
import AppPageHeader from '../components/AppPageHeader';
import { returnToMain } from '../utils/nav';
import { useTranslation } from 'react-i18next';
import ResetPwForm from '../usecases/resetpw/ResetPwForm';
import { strIsEmail } from '../utils/strings';
import ResetPwSuccess from '../usecases/resetpw/ResetPwSuccess';
import { apiResetPassword } from '../services/api';
import {
  getAppError,
  getUserMessageOrValidationError,
} from '../utils/messages';
import { useHistory } from 'react-router';
import { LoadingController } from '../utils/LoadingController';
import { useToaster } from '../hooks/useToaster';

const PasswordResetPage: React.FC = () => {
  const [t] = useTranslation('global');
  const [present] = useToaster();
  const router = useHistory();

  const [block, setBlock] = useState<string>('form');

  const [email, setEmail] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  const handlePasswordReset = async () => {
    if (isSubmitting) {
      return;
    }
    if (!strIsEmail(email)) {
      present(getAppError(t('resetpw.erroremail')));
      return;
    }
    try {
      LoadingController.show();
      setIsSubmitting(true);
      await apiResetPassword(email);

      setBlock('success');
    } catch (error) {
      console.error('Error occurred during password reset', error);
      const apiError = getUserMessageOrValidationError(error);
      if (typeof apiError === 'string') {
        present(getAppError(apiError));
      } else {
        present(getAppError(t('resetpw.nosuccess')));
      }
      setBlock('form');
    } finally {
      setIsSubmitting(false);
      LoadingController.hide();
    }
  };

  return (
    <IonPage id="resetpw-page">
      {block === 'form' && (
        <>
          <AppPageHeader isPageActive={isPageActive}
            back={() => returnToMain(router)}
            title={t('resetpw.title')}
          ></AppPageHeader>
          <IonContent fullscreen className="ion-padding default-content">
            <ResetPwForm
              proceed={handlePasswordReset}
              isValid={strIsEmail(email)}
              email={email}
              setEmail={setEmail}
            ></ResetPwForm>
          </IonContent>
        </>
      )}
      {block === 'success' && (
        <>
          <AppPageHeader isPageActive={isPageActive}
            back={() => setBlock('form')}
            title={t('resetpw.title')}
          ></AppPageHeader>
          <IonContent fullscreen className="ion-padding default-content">
            <ResetPwSuccess email={email}></ResetPwSuccess>
          </IonContent>
        </>
      )}
    </IonPage>
  );
};

export default PasswordResetPage;
